import React from 'react';

const OurPartners = () => {
    return (
        <div className='container align-items-center'>
            <hr />
            <h2 className='fw-light text-center my-4'>Our Partners</h2>
            <hr />
            <div className='row my-4'>
                <div className='col-lg-4 col-md-4 col-6 p-2 text-center'>
                    <img className='img-fluid' src="https://demo.proteusthemes.com/cargopress/wp-content/uploads/sites/24/2015/05/logo_1.png" alt="" />
                </div>
                <div className='col-lg-4 col-md-4 col-6 p-2 text-center'>
                    <img className='img-fluid' src="https://demo.proteusthemes.com/cargopress/wp-content/uploads/sites/24/2015/05/logo_2.png" alt="" />
                </div>
                <div className='col-lg-4 col-md-4 col-6 p-2 text-center'>
                    <img className='img-fluid' src="https://demo.proteusthemes.com/cargopress/wp-content/uploads/sites/24/2015/05/logo_3.png" alt="" />
                </div>
                <div className='col-lg-4 col-md-4 col-6 p-2 text-center'>
                    <img className='img-fluid' src="https://demo.proteusthemes.com/cargopress/wp-content/uploads/sites/24/2015/05/logo_4.png" alt="" />
                </div>
                <div className='col-lg-4 col-md-4 col-6 p-2 text-center'>
                    <img className='img-fluid' src="https://demo.proteusthemes.com/cargopress/wp-content/uploads/sites/24/2015/05/logo_5.png" alt="" />
                </div>
                <div className='col-lg-4 col-md-4 col-6 p-2 text-center'>
                    <img className='img-fluid' src="https://demo.proteusthemes.com/cargopress/wp-content/uploads/sites/24/2015/06/logo_6.png" alt="" />
                </div>
            </div>
        </div>
    );
};

export default OurPartners;